import { call, all, put, takeLatest } from 'redux-saga/effects';
import { HttpService } from '../../services/HttpService';
import * as Actions from './actions';
import * as Constants from './Constants';
// import { goToProcessStep } from '../../redirection';
import * as cartActions from '../../services/Cart/actions';

import * as getCheckOutAction from '../FuncComp/actions';

import * as binHelper from './helpers/binDetection';
import { getItemFromStore, saveItemToStore } from '../../utils/sessionStorage';
// import {
//   setSession, getSession,
// } from '../../components/common/Helpers/index';
import * as notificationActions from '../../components/common/NotificationBar/actions';
import logger from '../../components/common/ErrorBoundary/logger_new';
import { getSecureBaseUrl } from '../../services/UrlMapperService';
import { apiUrls } from '../../constants/apiUrl';
import { crossSiteCheckUrl, getServiceUrlandE2eRequestId, getSession, isFuncComp } from '../../components/common/Helpers/index';
import { getErrorLogObj } from '../../services/loggerService';
import { showLoader, hideLoader } from '../../components/common/Helpers/loader';

function* getPaymentOptions({ data }) {
  let errorDetails = {
    showError: false,
  };
  let serviceDetails = null;
  yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails });
  yield put({ type: Constants.ASYNC_FETCH });
  if (!getSession('paypalAuthFailed')) {
    yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: false, errorMessage: null });
  }
  try {
    showLoader();
    const apiResponse = yield call(Actions.getPaymentOptionsData, data);
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      yield put({ type: Constants.PAYMENT_OPTIONS_RECEIVED, response: apiResponse.data });
      yield put({ type: 'API_LOADED', response: true });
      // yield invokeTagging('cpc-selected_plan');
      hideLoader();
    } else {
      // eslint-disable-next-line no-lonely-if
      if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
        errorDetails = {
          notifyErrorMessage: 'Looks like something went wrong. Please try again later.',
          showError: true,
        };
        serviceDetails = getServiceUrlandE2eRequestId('getShippingInfoData', apiResponse);

        // const errorLog = getErrorLogObj({
        //   note: 'from getPaymentOptions sagas'.concat(apiResponse?.data?.errors?.message ? apiResponse?.data?.errors?.message : ''),
        //   serviceUrl: apiResponse?.config?.url,
        //   networkError: {
        //     error: apiResponse,
        //     response: apiResponse.data.errors || null,
        //   },
        // });
        // errorLog.e2erequestid = apiResponse?.headers?.e2erequestid;
        // logger(errorLog);
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getPaymentOptions ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);

        yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails, serviceinfo: serviceDetails });
        yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
      }
      // logError('getPaymentOptions', apiResponse.data.errors, FE_API_ERROR);
    }
  } catch (error) {
    if (error && error.response) {
      errorDetails = {
        notifyErrorMessage: 'Looks like something went wrong. Please try again later.',
        showError: true,
      };
      serviceDetails = {
        method: 'getPaymentOptions',
      };
      const errLog = getErrorLogObj({
        note: 'from getPaymentOptions sagas'.concat(error?.message ? error?.message : ''),
        serviceUrl: `${getSecureBaseUrl()}${apiUrls().paymentInfourl}`,
        networkError: {
          error,
          response: error.response || null,
          message: error?.message,
          stack: error?.stack,
          subEventType: 'FeErrorS',
        },
      });
      // console.log('Error===>', errLog);
      logger(errLog);
      // logError('getPaymentOptions', error, FE_API_JS_ERROR);
      yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails, serviceinfo: serviceDetails });
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* getApplePaySession(action) {
  let errorDetails = {
    showError: false,
  };
  let serviceDetails = null;
  yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails });
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: false, errorMessage: null });
  try {
    const postData = {
      orderNumber: action.orderNumber,
      locationCode: action.locationCode,
      triggerFrom: 'checkout',
      paymentType: 'applePay',
      endPointURL: action.validationURL,
    };
    const response = yield call(HttpService.post, action.url, postData);
    if (
      (response?.data?.status === Constants.API_SUCCESS_CODE && !response.data.errors) ||
      (response?.data?.status && response.data.status.toString() === Constants.API_SUCCESS_CODE)
    ) {
      const merchantSession = response.data.getSessionRes;
      yield put({
        type: Constants.UPDATE_APPLE_MERCHANT_SESSION,
        merchantSession,
      });

      try {
        if (merchantSession) {
          action.appleSessionObj.completeMerchantValidation(merchantSession);
        } else {
          yield put({ type: Constants.ASYNC_FETCH_FAILURE });
          throw new Error('MerchantSession not found');
        }
      } catch (err) {
        yield put({ type: Constants.ASYNC_FETCH_FAILURE });
      }
    } else {
      if (response && ((response.data && response.data.errors) || (response.request && response.request.status !== 200))) {
        errorDetails = {
          notifyErrorMessage: 'Looks like something went wrong. Please try again later.',
          showError: true,
        };
        serviceDetails = getServiceUrlandE2eRequestId('getApplePaySession', response);
        yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails, serviceinfo: serviceDetails });
        yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: true, errorMessage: response?.data?.errors[0]?.notifyMessage });
        // const errorLog = getErrorLogObj({
        //   note: 'from getApplePaySession sagas'.concat(response?.data?.errors?.message ? response?.data?.errors?.message : ''),
        //   serviceUrl: response?.config?.url,
        //   networkError: {
        //     error: response,
        //     response: response.data.errors || null,
        //   },
        // });
        // errorLog.e2erequestid = response?.headers?.e2erequestid;
        // logger(errorLog);
        if (response.data.loggerData) response.data.loggerData.note = `getApplePaySession ${response?.data?.loggerData.note}`;
        logger(response?.data?.loggerData);
      }
      yield put({ type: Constants.ASYNC_FETCH_FAILURE });
      // logError('getApplePaySession', response.data.errors, FE_API_ERROR);
      throw new Error('response empty or invalid structure');
    }
  } catch (error) {
    abortAppleSession(action.appleSessionObj);
    // displayError();
    if (error && error.response) {
      errorDetails = {
        notifyErrorMessage: 'Looks like something went wrong. Please try again later.',
        showError: true,
      };

      serviceDetails = {
        method: 'getApplePaySession',
      };
      const errLog = getErrorLogObj({
        note: 'from getApplePaySession sagas'.concat(error?.message ? error?.message : ''),
        serviceUrl: action.url,
        networkError: {
          error,
          response: error.response || null,
          message: error?.message,
          stack: error?.stack,
          subEventType: 'FeErrorS',
        },
      });
      logger(errLog);
      yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    yield put({ type: Constants.ASYNC_FETCH_FAILURE });
    // logger(errorLog);
    // logError('getApplePaySession', error, FE_API_JS_ERROR);
  }
}
function getErrorDetails() {
  const errorDetails = {
    notifyErrorMessage: 'Looks like something went wrong. Please try again later.',
    showError: true,
  };
  return errorDetails;
}

function* processApplePaySession(action) {
  let errorDetails = {
    showError: false,
  };
  let serviceDetails = null;

  yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails });
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: false, errorMessage: null });
  try {
    // const apiData = {
    //   paymentResponseJSON: action.paymentResponseJSON,
    //   // getCheckOutParams: HELPERS.getCheckoutParams(window.vzFlags.enableECPerformance ? 'processApplePaySession' : 'default'),
    // };
    const postData = {
      // eslint-disable-next-line radix
      orderNumber: parseInt(action.orderNumber),
      locationCode: action.locationCode,
      triggerFrom: 'checkout',
      paymentType: 'applePay',
      ...action.paymentResponseJSON,
    };
    const response = yield call(HttpService.post, action.url, postData);
    const data = response && response.data;
    if (
      data &&
      (data.status === Constants.API_SUCCESS_CODE || (data.status && data.status.toString() === Constants.API_SUCCESS_CODE)) &&
      !data.errors
    ) {
      yield put({
        type: Constants.UPDATE_APPLE_PAY_PROCESS_SESSION_STATUS,
        status: true,
      });

      try {
        action.appleSessionObj.completePayment(window.ApplePaySession.STATUS_SUCCESS);
        const newUrl = `${window.location.origin}/sales/home/orderreview.html`;
        window.location.href = crossSiteCheckUrl(newUrl);
        // window.location.href = window.location.origin + '/sales/home/orderreview.html';
      } catch (err) {
        yield put({ type: Constants.ASYNC_FETCH_FAILURE });
        return;
      }

      // refresh state with updated values
      //  yield call(refreshState, data.getCheckoutDetails, HELPERS.getCheckoutParams(window.vzFlags.enableECPerformance ? 'processApplePaySession' : 'default'));

      if (action.successCallback) {
        action.successCallback();
      }

      yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
    } else {
      if (data && (data.errors || (data.status && data.status.toString() !== Constants.API_SUCCESS_CODE))) {
        errorDetails = {
          notifyErrorMessage: 'Looks like something went wrong. Please try again later.',
          showError: true,
        };
        serviceDetails = getServiceUrlandE2eRequestId('processApplePaySession', response);

        // const errorLog = getErrorLogObj({
        //   note: 'from processApplePaySession sagas'.concat(response?.data?.errors?.message ? response?.data?.errors?.message : ''),
        //   serviceUrl: response?.config?.url,
        //   networkError: {
        //     error: response,
        //     response: response.data.errors || null,
        //   },
        // });
        // errorLog.e2erequestid = response?.headers?.e2erequestid;
        // logger(errorLog);
        if (response.data.loggerData) response.data.loggerData.note = `processApplePaySession ${response?.data?.loggerData.note}`;
        logger(response?.data?.loggerData);

        yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails, serviceinfo: serviceDetails });
        yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: true, errorMessage: response?.data?.errors[0]?.notifyMessage });
      }
      yield put({ type: Constants.ASYNC_FETCH_FAILURE });
      // logError('processApplePaySession', data.errors, FE_API_ERROR);
      throw new Error('response empty or invalid structure');
    }
  } catch (error) {
    abortAppleSession(action.appleSessionObj);
    // displayError();
    yield put({ type: Constants.ASYNC_FETCH_FAILURE });
    if (error && error.response) {
      serviceDetails = {
        method: 'getApplePaySession',
      };
      const errLog = getErrorLogObj({
        note: 'from getApplePaySession sagas'.concat(error?.message ? error?.message : ''),
        serviceUrl: `${getSecureBaseUrl()}${apiUrls().zipMarketDetailsUrl}`,
        networkError: {
          error,
          response: error.response || null,
          message: error?.message,
          stack: error?.stack,
          subEventType: 'FeErrorS',
        },
      });
      logger(errLog);
      yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails: getErrorDetails(), serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
  }
}

function abortAppleSession(appleSessionObj) {
  try {
    appleSessionObj.abort();
  } catch (err) {
    if (err) {
      console.log(err);
    }
  }
}

function* loginToPaypal(action) {
  let errorDetails = {
    showError: false,
  };
  let serviceDetails = null;
  yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails });
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: false, errorMessage: null });
  showLoader();
  try {
    const { paypalLookUpUrl, triggerFrom } = action;
    const response = yield call(Actions.loginPaypalAPI, paypalLookUpUrl, triggerFrom);
    hideLoader();
    if (response && response.data && response.data.status === 1 && !response.data.errors) {
      window.location.href = response.data.redirectURL;
    } else {
      // logError('loginToPaypal', response.data.errors, FE_API_ERROR);
      if ((response && response.data && response.data.errors) || (response.request && response.request.status !== 200)) {
        errorDetails = {
          notifyErrorMessage: 'Looks like something went wrong. Please try again later.',
          showError: true,
        };
        serviceDetails = getServiceUrlandE2eRequestId('loginToPaypal', response);
        yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails, serviceinfo: serviceDetails });
        yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: true, errorMessage: response?.data?.errors[0]?.notifyMessage });
      }
      // const errorLog = getErrorLogObj({
      //   note: 'from loginToPaypal sagas'.concat(response?.data?.errors?.message ? response?.data?.errors?.message : ''),
      //   serviceUrl: response?.config?.url,
      //   networkError: {
      //     error: response,
      //     response: response.data.errors || null,
      //   },
      // });
      // errorLog.e2erequestid = response?.headers?.e2erequestid;
      // logger(errorLog);
      if (response.data.loggerData) response.data.loggerData.note = `loginToPaypal ${response?.data?.loggerData.note}`;
      logger(response?.data?.loggerData);

      throw new Error('response empty or invalid structure');
    }
  } catch (error) {
    // logError('loginToPaypal', error, FE_API_JS_ERROR);
    if (error && error.response) {
      serviceDetails = {
        method: 'loginToPaypal',
      };
      const errLog = getErrorLogObj({
        note: 'from loginToPaypal sagas'.concat(error?.message ? error?.message : ''),
        serviceUrl: `${getSecureBaseUrl()}${apiUrls().zipMarketDetailsUrl}`,
        networkError: {
          error,
          response: error.response || null,
          message: error?.message,
          stack: error?.stack,
          subEventType: 'FeErrorS',
        },
      });
      logger(errLog);
      yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails: getErrorDetails(), serviceinfo: serviceDetails });
    }
    yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    yield put({
      type: Constants.ERR_RECEIVED,
      response: Constants.DEFAULT_ERR_MSG,
    });
  }
}

function* addCardDetails({ data }) {
  let errorDetails = {
    showError: false,
  };
  let serviceDetails = null;
  yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails });
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.SAVE_CARD_DETAILS, data });
  yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: false, errorMessage: null });
  try {
    showLoader();
    const isCardPayment = data?.selectedPaymentOption && (data?.selectedPaymentOption === 'CR' || data?.selectedPaymentOption === 'SC');
    const isSavedCard = data?.paymentType;
    if (isSavedCard === 'SC') {
      const apiResponseaddCardDetails = yield call(Actions.addSavedCardDetailsAPI, data);
      if (apiResponseaddCardDetails && apiResponseaddCardDetails.data && !apiResponseaddCardDetails.data.errors) {
        const is3dsEnabled =
          apiResponseaddCardDetails?.data &&
          apiResponseaddCardDetails.data['3DSecureEnabled'] &&
          apiResponseaddCardDetails.data['3DSecureEnabled'].toUpperCase() === 'Y' &&
          apiResponseaddCardDetails.data['3DsacsURL'] &&
          apiResponseaddCardDetails.data['3DsacsURL'] !== '';
        const isNon3D = apiResponseaddCardDetails && apiResponseaddCardDetails.data && apiResponseaddCardDetails.data.preAuthSuccess;
        if (is3dsEnabled) {
          yield put({ type: Constants.UPDATE_3DS_INFO, response: apiResponseaddCardDetails.data });
          yield put({ type: 'ENABLE_3D_CARD', response: 'Y' });
        } else if (isNon3D) {
          yield put({ type: Constants.IS_NON_3D_RECEIVED, response: true });
        }
        hideLoader();
      } else if (
        apiResponseaddCardDetails &&
        ((apiResponseaddCardDetails.data && apiResponseaddCardDetails.data.errors && apiResponseaddCardDetails.data.errors.length > 0) ||
          (apiResponseaddCardDetails.request && apiResponseaddCardDetails.request.status !== 200))
      ) {
        if (
          apiResponseaddCardDetails?.data?.errors?.length > 0 &&
          apiResponseaddCardDetails.data.errors[0] &&
          apiResponseaddCardDetails.data.errors[0].id &&
          apiResponseaddCardDetails.data.errors[0].id === '614'
        ) {
          serviceDetails = getServiceUrlandE2eRequestId('addCardDetailsmax', apiResponseaddCardDetails);
          yield put({ type: 'MAX_ATTEMPT_ERROR', response: true, serviceinfo: serviceDetails });
        }
        errorDetails = {
          notifyErrorMessage: apiResponseaddCardDetails.data.errors[0].message,
          showError: true,
        };
        serviceDetails = getServiceUrlandE2eRequestId('addCardDetails', apiResponseaddCardDetails);

        yield put({ type: Constants.CONFIRM_SUBMIT_CALL, value: true });
        yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails, serviceinfo: serviceDetails });
        yield put({
          type: Constants.CEF_PAYMENT_INFO_ERROR,
          response: true,
          errorMessage: apiResponseaddCardDetails?.data?.errors[0]?.notifyMessage,
        });
        if (!isFuncComp()) {
          yield call(getCartDetailsPayment, data);
        }
        hideLoader();
        // logError('addCardDetails', apiResponse.data.errors, FE_API_ERROR);
        // const errorLog = getErrorLogObj({
        //   note: 'from addCardDetails sagas'.concat(
        //     apiResponseaddCardDetails?.data?.errors?.message ? apiResponseaddCardDetails?.data?.errors?.message : '',
        //   ),
        //   serviceUrl: apiResponseaddCardDetails?.config?.url,
        //   networkError: {
        //     error: apiResponseaddCardDetails,
        //     response: apiResponseaddCardDetails.data.errors || null,
        //   },
        // });
        // errorLog.e2erequestid = apiResponseaddCardDetails?.headers?.e2erequestid;
        // logger(errorLog);
        if (apiResponseaddCardDetails.data.loggerData)
          apiResponseaddCardDetails.data.loggerData.note = `addCardDetails ${apiResponseaddCardDetails?.data?.loggerData.note}`;
        logger(apiResponseaddCardDetails?.data?.loPAYMENT_SUCESSggerData);

        hideLoader();
      }
    } else if (data && data.isBTA && data.isBTA.paymentType === 'AC' && !isCardPayment) {
      const apiResponseAlt = yield call(Actions.addB2ACardDetailsToAPI, data);
      console.log(apiResponseAlt);
      if (apiResponseAlt && apiResponseAlt.data && !apiResponseAlt.data.errors) {
        yield put({ type: Constants.CONFIRM_SUBMIT_CALL, value: true });
        yield put({ type: Constants.PAYMENT_SUCESS, apiResponse: apiResponseAlt });
        if (isFuncComp()) {
          yield call(getCheckOutAction.getCheckOutDetails({ cart: true }));
        } else {
          getCartDetailsPayment();
        }
        hideLoader();
      } else if (
        apiResponseAlt &&
        ((apiResponseAlt.data && apiResponseAlt.data.errors && apiResponseAlt.data.errors.length > 0) ||
          (apiResponseAlt.request && apiResponseAlt.request.status !== 200))
      ) {
        if (
          apiResponseAlt?.data?.errors?.length > 0 &&
          apiResponseAlt.data.errors[0] &&
          apiResponseAlt.data.errors[0].id &&
          apiResponseAlt.data.errors[0].id === '614'
        ) {
          serviceDetails = getServiceUrlandE2eRequestId('addB2ACardDetailsToAPIMax', apiResponseAlt);
          yield put({ type: 'MAX_ATTEMPT_ERROR', response: true, serviceinfo: serviceDetails });
        }
        errorDetails = {
          notifyErrorMessage: apiResponseAlt.data.errors[0].message,
          showError: true,
        };
        serviceDetails = getServiceUrlandE2eRequestId('addB2ACardDetailsToAPI', apiResponseAlt);

        yield put({ type: Constants.CONFIRM_SUBMIT_CALL, value: true });
        yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails, serviceinfo: serviceDetails });
        yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: true, errorMessage: apiResponseAlt?.data?.errors[0]?.notifyMessage });
        if (!isFuncComp()) {
          getCartDetailsPayment();
        }
        hideLoader();
        // logError('addCardDetails', apiResponse.data.errors, FE_API_ERROR);
        // const errorLog = getErrorLogObj({
        //   note: 'from addCardDetails sagas'.concat(apiResponseAlt?.data?.errors?.message ? apiResponseAlt?.data?.errors?.message : ''),
        //   serviceUrl: apiResponseAlt?.config?.url,
        //   networkError: {
        //     error: apiResponseAlt,
        //     response: apiResponseAlt.data.errors || null,
        //   },
        // });
        // errorLog.e2erequestid = apiResponseAlt?.headers?.e2erequestid;
        // logger(errorLog);
        if (apiResponseAlt.data.loggerData) apiResponseAlt.data.loggerData.note = `addCardDetails ${apiResponseAlt?.data?.loggerData.note}`;
        logger(apiResponseAlt?.data?.loggerData);
      }
    } else if (isCardPayment) {
      const binDectionNumber =
        data && data.showSelectedCard && data.showSelectedCard.encCardInfo && data.showSelectedCard.encCardInfo.encryptedCardData
          ? data.showSelectedCard.encCardInfo.encryptedCardData.substring(0, 6)
          : '';
      const binProcessMaxTimeout = data.binProcessEventMaxTimeout;
      const d2dPage = window.location.href.indexOf('dtd') > -1;
      if (!d2dPage) {
        if (binProcessMaxTimeout < 0) {
          yield call(binHelper.binProcess, binDectionNumber);
        } else {
          yield call(binHelper.binProcessWithTimeout, binDectionNumber, binProcessMaxTimeout);
        }
      }
      const apiResponse = yield call(Actions.addCardDetailsAPI, data);
      if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
        const is3dsEnabled =
          apiResponse?.data &&
          apiResponse.data['3DSecureEnabled'] &&
          apiResponse.data['3DSecureEnabled'].toUpperCase() === 'Y' &&
          apiResponse.data['3DsacsURL'] &&
          apiResponse.data['3DsacsURL'] !== '';
        const isNon3D = apiResponse && apiResponse.data && apiResponse.data.preAuthSuccess;
        if (is3dsEnabled && !d2dPage) {
          yield put({ type: Constants.UPDATE_3DS_INFO, response: apiResponse.data });
          yield put({ type: 'ENABLE_3D_CARD', response: 'Y' });
        } else if (isNon3D) {
          yield put({ type: Constants.CONFIRM_SUBMIT_CALL, value: true });
          yield put({ type: Constants.PAYMENT_SUCESS, apiResponse });
          yield put({ type: Constants.IS_NON_3D_RECEIVED, response: isNon3D });
          if (!isFuncComp()) {
            yield call(getCartDetailsPayment, data);
          }
        } else if (is3dsEnabled && d2dPage) {
          yield put({ type: Constants.UPDATE_3DS_INFO, response: apiResponse.data });
          yield put({ type: 'ENABLE_3D_CARD', response: 'Y' });
          // yield call(handle3dPaymentValidatedD2D, data);
          // yield put({ type: Constants.CONFIRM_SUBMIT_CALL, value: true });
          // yield put({ type: Constants.PAYMENT_SUCESS, apiResponse });
        }

        hideLoader();
      } else if (
        apiResponse &&
        ((apiResponse.data && apiResponse.data.errors && apiResponse.data.errors.length > 0) ||
          (apiResponse.request && apiResponse.request.status !== 200))
      ) {
        if (
          apiResponse?.data?.errors?.length > 0 &&
          apiResponse.data.errors[0] &&
          apiResponse.data.errors[0].id &&
          apiResponse.data.errors[0].id === '614'
        ) {
          serviceDetails = getServiceUrlandE2eRequestId('addCardDetailsMax', apiResponse);
          yield put({ type: 'MAX_ATTEMPT_ERROR', response: true, serviceinfo: serviceDetails });
        }
        errorDetails = {
          notifyErrorMessage: apiResponse.data.errors[0].message,
          showError: true,
        };
        serviceDetails = getServiceUrlandE2eRequestId('addCardDetails', apiResponse);

        yield put({ type: Constants.CONFIRM_SUBMIT_CALL, value: true });
        yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails, serviceinfo: serviceDetails });
        yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
        // yield call(getCartDetailsPayment, data);
        hideLoader();
        // logError('addCardDetails', apiResponse.data.errors, FE_API_ERROR);
        // const errorLog = getErrorLogObj(apiResponse, {
        //   note: 'from addCardDetails sagas'.concat(apiResponse?.data?.errors?.message ? apiResponse?.data?.errors?.message : ''),
        //   serviceUrl: apiResponse?.config?.url,
        //   networkError: {
        //     error: apiResponse,
        //     response: apiResponse.data.errors || null,
        //   },
        // });
        // errorLog.e2erequestid = apiResponse?.headers?.e2erequestid;
        // logger(errorLog);
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `addCardDetails ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
      }
    }
  } catch (error) {
    if (error && error.response) {
      errorDetails = {
        notifyErrorMessage: 'Looks like something went wrong. Please try again later.',
        showError: true,
      };
      serviceDetails = {
        method: 'addCardDetails',
      };
      const errLog = getErrorLogObj({
        note: 'from addCardDetails sagas'.concat(error?.message ? error?.message : ''),
        serviceUrl: `${getSecureBaseUrl()}${apiUrls().confirmSubmitUrl}`,
        networkError: {
          error,
          response: error.response || null,
          message: error?.message,
          stack: error?.stack,
          subEventType: 'FeErrorS',
        },
      });
      logger(errLog);
      yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    hideLoader();
    // logError('addCardDetails', error, FE_API_JS_ERROR);
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* handle3dPaymentValidated(action) {
  let errorDetails = {
    showError: false,
  };
  let serviceDetails = null;
  yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails });
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: false, errorMessage: null });
  try {
    const apiResponsehandle3dPaymentValidated = yield call(Actions.handle3dPaymentValidatedAPI, action);
    if (apiResponsehandle3dPaymentValidated && apiResponsehandle3dPaymentValidated.data && !apiResponsehandle3dPaymentValidated.data.errors) {
      yield put({ type: Constants.CONFIRM_SUBMIT_CALL, value: true });
      yield put({ type: Constants.PAYMENT_SUCESS, apiResponse: apiResponsehandle3dPaymentValidated });
      if (!isFuncComp()) {
        getCartDetailsPayment();
      }
      hideLoader();
    } else if (
      apiResponsehandle3dPaymentValidated &&
      ((apiResponsehandle3dPaymentValidated.data &&
        apiResponsehandle3dPaymentValidated.data.errors &&
        apiResponsehandle3dPaymentValidated.data.errors.length > 0) ||
        (apiResponsehandle3dPaymentValidated.request && apiResponsehandle3dPaymentValidated.request.status !== 200))
    ) {
      if (
        apiResponsehandle3dPaymentValidated?.data?.errors?.length > 0 &&
        apiResponsehandle3dPaymentValidated.data.errors[0] &&
        apiResponsehandle3dPaymentValidated.data.errors[0].id &&
        apiResponsehandle3dPaymentValidated.data.errors[0].id === '614'
      ) {
        yield put({ type: 'MAX_ATTEMPT_ERROR', response: true });
      }
      errorDetails = {
        notifyErrorMessage: apiResponsehandle3dPaymentValidated.data.errors[0].message,
        showError: true,
      };
      serviceDetails = getServiceUrlandE2eRequestId('handle3dPaymentValidated', apiResponsehandle3dPaymentValidated);
      hideLoader();
      yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails, serviceinfo: serviceDetails });
      yield put({ type: Constants.CONFIRM_SUBMIT_CALL, value: true });
      yield put({
        type: Constants.CEF_PAYMENT_INFO_ERROR,
        response: true,
        errorMessage: apiResponsehandle3dPaymentValidated?.data?.errors[0]?.notifyMessage,
      });
      if (!isFuncComp()) {
        getCartDetailsPayment();
      }
      // logError('handle3dPaymentValidated', apiResponse.data.errors, FE_API_ERROR);
      // const errorLog = getErrorLogObj({
      //   note: 'from handle3dPaymentValidated sagas'.concat(
      //     apiResponsehandle3dPaymentValidated?.data?.errors?.message ? apiResponsehandle3dPaymentValidated?.data?.errors?.message : '',
      //   ),
      //   serviceUrl: apiResponsehandle3dPaymentValidated?.config?.url,
      //   networkError: {
      //     error: apiResponsehandle3dPaymentValidated,
      //     response: apiResponsehandle3dPaymentValidated.data.errors || null,
      //   },
      // });
      // errorLog.e2erequestid = apiResponsehandle3dPaymentValidated?.headers?.e2erequestid;
      // logger(errorLog);
      if (apiResponsehandle3dPaymentValidated.data.loggerData)
        apiResponsehandle3dPaymentValidated.data.loggerData.note = `handle3dPaymentValidated ${apiResponsehandle3dPaymentValidated?.data?.loggerData.note}`;
      logger(apiResponsehandle3dPaymentValidated?.data?.loggerData);
    }
  } catch (error) {
    // logError('handle3dPaymentValidated', error, FE_API_JS_ERROR);
    serviceDetails = {
      method: 'handle3dPaymentValidated',
    };

    if (error && error.response) {
      errorDetails = {
        notifyErrorMessage: 'Looks like something went wrong. Please try again later.',
        showError: true,
      };
      const errLog = getErrorLogObj({
        note: 'from handle3dPaymentValidated sagas'.concat(error?.message ? error?.message : ''),
        serviceUrl: `${getSecureBaseUrl()}${apiUrls().handle3DCardinalResponse}`,
        networkError: {
          error,
          response: error.response || null,
          message: error?.message,
          stack: error?.stack,
          subEventType: 'FeErrorS',
        },
      });
      logger(errLog);
      yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
  }
}

function* getPaypalDetails({ data }) {
  let errorDetails = {
    showError: false,
  };
  let serviceDetails = null;
  yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails });
  yield put({ type: Constants.ASYNC_FETCH });
  yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: false, errorMessage: null });
  try {
    yield call(cartActions.getCartDetails, { pageName: data });
    // if (response && response[0].data) {
    //   yield put({ type: Constants.IS_PAYPAL_CHOOSEN, paypalDataPosted: true });
    // }
  } catch (error) {
    if (error && error.response) {
      errorDetails = {
        notifyErrorMessage: 'Looks like something went wrong. Please try again later.',
        showError: true,
      };
      serviceDetails = {
        method: 'getPaypalDetails',
      };

      yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* showErrorNotification({ data }) {
  let ccAttempts = getItemFromStore('ccAttempts');
  let serviceDetails = null;
  if (getItemFromStore('ccAttempts') !== undefined && getItemFromStore('ccAttempts') !== null && getItemFromStore('ccAttempts') !== '') {
    const val = getItemFromStore('ccAttempts');
    ccAttempts = (parseInt(val), 10);
    saveItemToStore('ccAttempts', ccAttempts + 1);
  }
  const errorDetails = {
    notifyErrorMessage: data || Constants.DEFAULT_ERROR_MESSAGE,
    showError: true,
    ccAttempts,
  };
  serviceDetails = {
    method: 'ccAttempts',
  };
  yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails, serviceinfo: serviceDetails });
  yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: errorDetails.showError, errorMessage: errorDetails.notifyErrorMessage });
}

function* hideNotification() {
  const errorDetails = {
    // notifyErrorMessage: data,
    showError: false,
  };
  yield put({ type: Constants.REMOVE_NOTIFICATION, errorDetails });
  yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: false, errorMessage: null });
}

function* postTOSSendLinkDetails({ data }) {
  let errorDetails = {
    showError: false,
  };
  yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails });
  yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: false, errorMessage: null });
  const notifyErrorMessage = data.notifyMessage;
  yield put(notificationActions.hideNotification());
  try {
    showLoader();
    const apiResponse = yield call(Actions.postTOSSendLinkDetailsAPI, data);
    if (apiResponse && apiResponse.data && apiResponse.data.statusCode === '200') {
      yield put({ type: 'POST_SEND_LINK_RESPONSE', response: apiResponse.data });
      hideLoader();
    } else {
      yield put(notificationActions.showErrorNotification(notifyErrorMessage));
      // logError('postTOSSendLinkDetails', apiResponse.data.errors, FE_API_ERROR);
      if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
        errorDetails = {
          notifyErrorMessage: 'Looks like something went wrong. Please try again later.',
          showError: true,
        };
        // const errorLog = getErrorLogObj({
        //   note: 'from postTOSSendLinkDetails sagas'.concat(apiResponse?.data?.errors?.message ? apiResponse?.data?.errors?.message : ''),
        //   serviceUrl: apiResponse?.config?.url,
        //   networkError: {
        //     error: apiResponse,
        //     response: apiResponse.data.errors || null,
        //   },
        // });
        // errorLog.e2erequestid = apiResponse?.headers?.e2erequestid;
        // logger(errorLog);
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `postTOSSendLinkDetails ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);

        yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
      }
      yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails });
    }
  } catch (error) {
    if (error && error.response) {
      errorDetails = {
        notifyErrorMessage: 'Looks like something went wrong. Please try again later.',
        showError: true,
      };
      const errLog = getErrorLogObj({
        note: 'from postTOSSendLinkDetails sagas'.concat(error?.message ? error?.message : ''),
        serviceUrl: `${getSecureBaseUrl()}${apiUrls().inspicioSendMessage}`,
        networkError: {
          error,
          response: error.response || null,
          message: error?.message,
          stack: error?.stack,
          subEventType: 'FeErrorS',
        },
      });
      logger(errLog);
      yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails });
      yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    // logError('postTOSSendLinkDetails', error, FE_API_JS_ERROR);
    hideLoader();
  }
}

function* getCartDetailsPayment({ data }) {
  let errorDetails = {
    showError: false,
  };
  let serviceDetails = null;
  yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails });
  yield put({ type: Constants.ASYNC_FETCH });
  if (!getSession('paypalAuthFailed')) {
    yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: false, errorMessage: null });
  }
  try {
    showLoader();

    const apiResponse = yield call(cartActions.getCartDetails, { pageName: data });
    if (apiResponse && apiResponse.data && !apiResponse.data.errors) {
      yield put({ type: Constants.GET_DATA_SUCCESS, response: apiResponse.data });
      hideLoader();
    } else {
      // logError('getDataFromApi', apiResponse.data.errors, FE_API_ERROR);
      if (apiResponse && ((apiResponse.data && apiResponse.data.errors) || (apiResponse.request && apiResponse.request.status !== 200))) {
        errorDetails = {
          notifyErrorMessage: 'Looks like something went wrong. Please try again later.',
          showError: true,
        };
        serviceDetails = getServiceUrlandE2eRequestId('getCartDetailsPayment', apiResponse);
        yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails, serviceinfo: serviceDetails });
        yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: true, errorMessage: apiResponse?.data?.errors[0]?.notifyMessage });
        // const errorLog = getErrorLogObj({
        //   note: 'from getCartDetailsPayment sagas'.concat(apiResponse?.data?.errors?.message ? apiResponse?.data?.errors?.message : ''),
        //   serviceUrl: apiResponse?.config?.url,
        //   networkError: {
        //     error: apiResponse,
        //     response: apiResponse.data.errors || null,
        //   },
        // });
        // errorLog.e2erequestid = apiResponse?.headers?.e2erequestid;
        // logger(errorLog);
        if (apiResponse.data.loggerData) apiResponse.data.loggerData.note = `getCartDetailsPayment ${apiResponse?.data?.loggerData.note}`;
        logger(apiResponse?.data?.loggerData);
      }
      throw apiResponse;
    }
  } catch (error) {
    if (error && error.response) {
      errorDetails = {
        notifyErrorMessage: 'Looks like something went wrong. Please try again later.',
        showError: true,
      };
      serviceDetails = {
        method: 'getCartDetailsPayment',
      };
      yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails, serviceinfo: serviceDetails });
      yield put({ type: Constants.CEF_PAYMENT_INFO_ERROR, response: true, errorMessage: Constants.DEFAULT_ERROR_MESSAGE });
    }
    hideLoader();
  }
  yield put({ type: Constants.ASYNC_FETCH_SUCCESS });
}

function* getPaymentZipCodeDetails(zipCode) {
  let errorDetails = {
    showError: false,
  };
  let serviceDetails = null;
  yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails });
  try {
    const apiResponse = yield call(Actions.getPaymentZipCodeDetailsApi, zipCode);
    if (
      apiResponse &&
      ((apiResponse.data && apiResponse.data.errors && apiResponse.data.errors.length > 0) ||
        (apiResponse.request && apiResponse.request.status !== 200))
    ) {
      yield put({ type: 'PAYMENT_ZIP_DETAILS_FAILED', response: true });
      serviceDetails = getServiceUrlandE2eRequestId('getPaymentZipCodeDetails', apiResponse);
    } else {
      yield put({ type: 'PAYMENT_ZIP_DETAILS_FAILED', response: false });
    }
  } catch (error) {
    if (error && error.response) {
      errorDetails = {
        notifyErrorMessage: 'Looks like something went wrong. Please try again later.',
        showError: true,
      };
      serviceDetails = getServiceUrlandE2eRequestId('getPaymentZipCodeDetails', error.response);
      yield put({ type: Constants.SHOW_PAYMENT_API_ERROR, errorDetails, serviceinfo: serviceDetails });
      const errorLog = getErrorLogObj({
        note: 'from getPaymentZipCodeDetails sagas'.concat(error?.message ? error?.message : ''),
        serviceUrl: `${getSecureBaseUrl()}${apiUrls().zipMarketDetailsUrl}`,
        networkError: {
          error,
          response: error.response || null,
          message: error?.message,
          stack: error?.stack,
          subEventType: 'FeErrorS',
        },
      });
      logger(errorLog);
    }
    // logError('getPaymentZipCodeDetails', error, FE_API_JS_ERROR);
    hideLoader();
  }
}

function* actionWatcher() {
  yield takeLatest(Constants.GET_PAYMENT_OPTIONS, getPaymentOptions);
  yield takeLatest(Constants.GET_APPLE_PAY_SESSION, getApplePaySession);
  yield takeLatest(Constants.PROCESS_APPLE_PAY_SESSION, processApplePaySession);
  yield takeLatest(Constants.PAYPAL_LOGIN, loginToPaypal);
  yield takeLatest(Constants.ADD_CARD_DETAILS_TO_CART, addCardDetails);
  yield takeLatest(Constants.HANDLE_3D_PAYMENT_VALIDATED, handle3dPaymentValidated);
  // yield takeLatest('D2D_HANDLE_3D_PAYMENT_VALIDATED', handle3dPaymentValidatedD2D);
  yield takeLatest(Constants.GET_PAYPAL_DETAILS_FROM_CART, getPaypalDetails);
  yield takeLatest(Constants.SHOW_NOTIFICATION, showErrorNotification);
  yield takeLatest(Constants.HIDE_NOTIFICATION, hideNotification);
  yield takeLatest(Constants.GET_CART_DETAILS_PAYMENT, getCartDetailsPayment);
  yield takeLatest('POST_SEND_LINK_DETAILS', postTOSSendLinkDetails);
  yield takeLatest(Constants.GET_PAYMENT_ZIP_DETAILS, getPaymentZipCodeDetails);
}

export default function* rootSaga() {
  yield all([actionWatcher()]);
}
